module.exports = __webpack_public_path__ + "media/images/portal/i-1-1bfb3ab472ad25189a8f6511a1f8d8fa.png";